import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pullRequestUpdated: {
    id: 'frontbucket.pullRequest.updatedFlagTitle',
    description:
      'Title for the popup flag which tells a user the pull request has been updated.',
    defaultMessage: 'This pull request was updated',
  },
  anchorMovedTitle: {
    id: 'frontbucket.pullRequest.anchorMovedTitle',
    description:
      'Title for the popup flag which tells a user the source branch for a pull request has been updated.',
    defaultMessage: 'Source branch updated',
  },
  anchorMovedDescription: {
    id: 'frontbucket.pullRequest.anchorMovedDescription',
    description:
      'Body text for the popup flag which tells a user the source branch for a pull request has been updated.',
    defaultMessage: 'The source branch for this pull request has been updated.',
  },
  reload: {
    id: 'frontbucket.pullRequest.reloadAction',
    description: 'Link to reload the page.',
    defaultMessage: 'Reload page',
  },
  discardCommentsModalBody: {
    id: 'frontbucket.pullRequest.updatedFlagTitle.discardCommentsModalBody',
    description:
      'Body text of a confirmation dialog. Explains that unsaved comments will be lost upon reloading pull request.',
    defaultMessage:
      'Reloading the pull request discards your unsaved comments.',
  },
  topicDiffConflictTitle: {
    id: 'frontbucket.pullRquest.topicDiffRolloutConflictsFlag.title',
    description:
      'Title for flag informing the user of the topic diff rollout and why conflicts look different now',
    defaultMessage: 'Merge conflicts look a bit different now',
  },
  topicDiffConflictBody: {
    id: 'frontbucket.pullRquest.topicDiffRolloutConflictsFlag.body',
    description:
      'Body for flag informing the user of the topic diff rollout and why conflicts look different now',
    defaultMessage:
      'To help improve performance, we’ve updated the way our diffs are displayed. Now, files with merge conflicts are still marked as conflicted, but no longer display the conflicts in highlighted text on the diffs.',
  },
  pullRequestQueuedDrainingError: {
    id: 'frontbucket.pullRequest.queuedDrainingError',
    description:
      'Body for flag informing the user that queueing pull request has failed due to draining merge queue',
    defaultMessage:
      'Unable to add the pull request to the merge queue as the merge queue is draining.',
  },
  pullRequestQueuedError: {
    id: 'frontbucket.pullRequest.queuedError',
    description:
      'Body for flag informing the user that queueing pull request has failed due to other reason',
    defaultMessage: 'Failed to add the pull request to the merge queue.',
  },
  pullRequestRemoveFromQueueSuccess: {
    id: 'frontbucket.pullRequest.removeFromQueueSuccess',
    description: 'Success message after removing a pull request from the queue',
    defaultMessage:
      'Request to remove the pull request from the queue has been sent successfully.',
  },
  pullRequestRemoveFromQueueError: {
    id: 'frontbucket.pullRequest.removeFromQueueError',
    description: 'Error message after removing a pull request from the queue',
    defaultMessage: 'Failed to remove the pull request from the queue.',
  },
});
